// Simple event bus to request app openings from any component

export function openApp(name, payload = {}) {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(
      new CustomEvent('xp-open-app', { detail: { name, payload } }),
    );
  }
}

export function setWallpaper(url) {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(
      new CustomEvent('xp-set-wallpaper', { detail: { url } }),
    );
  }
}
